<template>
  <div>
    <v-snackbar top :color="snackbar.color" v-model="snackbar.model">{{
      snackbar.msg
    }}</v-snackbar>

    <v-row>
      <!-- add agent -->
      <v-col cols="12" md="4" order-md="2">
        <v-toolbar v-bind="toolbarProps">ADD AGENT</v-toolbar>

        <v-form
          ref="form"
          v-model="valid"
          :lazy-validation="lazy"
          @submit.prevent="addAgent"
        >
          <v-row no-gutters>
            <v-col cols="12" class="mb-2">
              <v-text-field
                placeholder="name"
                :rules="[rules.required, rules.name]"
                v-bind="fieldProps"
                v-model="agent.name"
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" class="mb-2">
              <v-text-field
                ref="email"
                placeholder="email"
                :rules="[rules.required, rules.email]"
                v-bind="fieldProps"
                v-model="agent.email"
                dense
              >
              </v-text-field>
            </v-col>

            <div style="width: 100%" class="d-flex justify-end flex-wrap mt-6">
              <v-btn
                :loading="loading.btn"
                :disabled="!valid || loading.btn"
                depressed
                class="primary ml-3"
                type="submit"
                >add</v-btn
              >
            </div>
          </v-row>
        </v-form>
      </v-col>

      <!-- all agents -->
      <v-col cols="12" md="8" order-md="1">
        <v-toolbar v-bind="toolbarProps">AGENTS</v-toolbar>

        <v-data-table
          :search="search"
          :headers="headers"
          :items="tableItems"
          class="elevation-1"
          :loading="loading.table"
          v-model="selected"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-text-field
                prepend-inner-icon="mdi-magnify"
                placeholder="search"
                v-bind="fieldProps"
                v-model="search"
                dense
              ></v-text-field>
            </v-toolbar>
          </template>

          <!-- <template v-slot:item.actions="{ item }">
            <v-icon small @click="handleAction(item)">
              mdi-delete
            </v-icon>
          </template> -->
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  rules,
  fieldProps,
  labelProps,
  toSentenceCase,
  toolbarProps,
} from "@/helpers";
import { mapActions } from "vuex";

export default {
  data: () => ({
    rules,
    fieldProps: { ...fieldProps },
    labelProps,
    toolbarProps,

    valid: true,
    lazy: false,

    snackbar: {
      model: false,
      msg: "Error!",
      color: "error",
    },

    tableItems: [],
    selected: [],

    loading: {
      table: false,
      btn: false,
    },

    search: "",

    agent: {
      name: "",
      email: "",
    },

    // headers
    headers: [
      {
        text: "NAME",
        align: "start",
        value: "name",
      },
      {
        text: "EMAIL",
        value: "email",
      },

      // { text: "ACTIONS", value: "actions", sortable: false },
    ],
  }),

  computed: {
    agents() {
      return this.$store.getters.getCollection("agents");
    },
  },

  methods: {
    ...mapActions(["makeFetch", "updateCollection"]),

    // handleAction(item) {
    //   console.log(item);
    // },

    showSnackbar(event) {
      this.snackbar.msg = !event.pre ? toSentenceCase(event.msg) : event.msg;
      this.snackbar.color = event.color;
      this.snackbar.model = true;
    },

    async addAgent() {
      if (!this.$refs.form.validate()) return;

      this.loading.btn = true;

      const data = this.agent;

      const res = await this.makeFetch({
        method: "post",
        goTo: "/polls",
        useId: this.$route.params.id,
        way: "/agents",
        data: data,
      })
        .catch(console.error)
        .finally(() => (this.loading.btn = false));

      if (res.success) {
        this.agent.name = "";
        this.agent.email = "";

        this.updateCollection({
          cn: "agents",
          data: res.data.data,
          mode: "push",
        });
      }

      this.showSnackbar({
        msg: res.success
          ? "Added"
          : res.message
          ? res.message
          : "Connection error. Please try again later!",
        color: res.success ? "primary" : "error",
        pre: !res.success && !res.message,
      });
    },
  },

  async mounted() {
    this.loading.table = true;
    await this.makeFetch({
      method: "get",
      goTo: `/polls/${this.$route.params.id}`,
      way: "/agents",
      stateVar: "agents",
    })
      .catch(console.error)
      .finally(() => {
        this.loading.table = false;
      });
  },

  watch: {
    agents(val) {
      this.tableItems = [...val];
    },
  },
};
</script>

<style>
.is-pressed {
  box-shadow: inset 0 2px 1px -1px rgba(0, 0, 0, 0.2),
    inset 0 1px 1px 0 rgba(0, 0, 0, 0.14), inset 0 1px 3px 0 rgba(0, 0, 0, 0.12) !important;
}
</style>
